import { createContext, createRef } from 'react';

import type { HeaderPortalContext } from 'src/modules/renderings/provider/types';

const context = createContext<HeaderPortalContext>({ ref: createRef() });

export { context };
